__turbopack_context__.v({
  "ctaWrapper": "_3txOzG_ctaWrapper",
  "desktopImage": "_3txOzG_desktopImage",
  "mobileImage": "_3txOzG_mobileImage",
  "productWrapper": "_3txOzG_productWrapper",
  "section": "_3txOzG_section",
  "tagline": "_3txOzG_tagline",
  "textBlock": "_3txOzG_textBlock",
  "wordmark": "_3txOzG_wordmark",
});
